import { tagManager } from '@src/tags/utils/tagManager';

export const qrTags = {
  QR_Popup_View: () => {
    // 적립_QR_조회
    tagManager('QR_Popup_View');
  },
};
